import { render, staticRenderFns } from "./productTheLayout.vue?vue&type=template&id=3156b09a&scoped=true&"
import script from "./productTheLayout.vue?vue&type=script&lang=js&"
export * from "./productTheLayout.vue?vue&type=script&lang=js&"
import style0 from "./productTheLayout.vue?vue&type=style&index=0&id=3156b09a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3156b09a",
  null
  
)

export default component.exports